/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import  Carousel from 'mfcl/Carousel';
import * as React from 'react';
import _getViewPort from '../../Utilities/get-view-port';
import { IMfrmSliderNavigationViewProps } from './mfrm-slider-navigation';
import classname from 'classnames';

export default (props: IMfrmSliderNavigationViewProps) => {
    const [loaded, setIsLoaded] = React.useState(false);
    const hideLoader = () => {
        setIsLoaded(true);
    };
    const styles = 'mfrm-slider-navigation__';
    const {
        config: { heading, headingColor },
        sliderNavigationItems
    } = props;

    let headingDisplay = null;
    if (heading && heading.text) {
        const HeadingTag = heading.tag ? (`${heading.tag}` as keyof JSX.IntrinsicElements) : 'h2';
        headingDisplay = (
            <div className='row'>
                <HeadingTag className={classname(`${styles}heading`, headingColor ? `${styles}text-${headingColor}` : '')}>{heading.text}</HeadingTag>
            </div>
        );
    }

 React.useEffect(hideLoader, []);
    return (
        <div className='mfrm-slider-navigation' data-cy='Sleep-Distrupter_Navigation'>
            {headingDisplay}
            <div className={`mfcl-carousel__container ${loaded ? '' : 'carousel-loading'}`}>
                <Carousel
                    itemsToShow={1}
                    hideIndicators
                    disableControls
                    variableWidth
                    ariaLabel="one"
                >
                    {sliderNavigationItems}
                </Carousel>
            </div>
        </div>
    );
};